import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-808594e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Darum lohnt sich unsere kostenlose Online-Immobilienbewertung")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Wie funktioniert die Immobilienbewertung mit immowelt?")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Was kostet die Immobilienbewertung von immowelt?")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sd_link = _resolveComponent("sd-link")!
  const _component_info_box = _resolveComponent("info-box")!

  return (_openBlock(), _createBlock(_component_info_box, {
    title: "Über die Immobilienbewertung",
    "is-grey": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_sd_link, {
            href: "#reasons",
            arrow: "none"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_sd_link, {
            href: "#steps",
            arrow: "none"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_sd_link, {
            href: "#cost",
            arrow: "none"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}